// Copyright (c) 2016 Deere & Company

export const getElementOffsetHeight = elementClassName => {

    const element = document.getElementsByClassName(elementClassName)[0];

    return element ? element.offsetHeight : null;

};

export const getElementOffsetTop = elementClassName => {

    const element = document.getElementsByClassName(elementClassName)[0];

    return element ? element.offsetTop : null;

};

export const getWindowHeight = () => {

    const screen = document.body.parentNode;

    return screen ? screen.clientHeight : null;

};

export const resizeReportGrid = newSize => {

    const reportElement = document.getElementsByClassName('report-grid')[0];

    if (reportElement) {

        reportElement.style.height = `${newSize}px`;

    }

};

export const scrollWindowXTo = newOffset => {

    if (window) {

        window.scroll(0, newOffset);

    }

};



// WEBPACK FOOTER //
// ./src/reports/shared/services/window-helpers.js